import * as actionTypes from '../actions/actionTypes';

export const initialState = {
  fonctions: [], // Liste des fonctions
  isLoading: false, // État de chargement
  error: null, // Erreur éventuelle
  tasks: [], // Liste des tâches (chaque tâche contient des fonctions)
};

const setFunctions = (state, action) => {
  return {
    ...state,
    fonctions: action.functions,
    error: null,
  };
};

const setFunctionsLoading = (state, action) => {
  return {
    ...state,
    isLoading: action.isLoading,
  };
};

const addFunction = (state, action) => {
  const newFonctions = [...state.fonctions, action.functionData];
  return {
    ...state,
    fonctions: newFonctions,
    error: null,
  };
};

const updateFunction = (state, action) => {
  const newFonctions = state.fonctions.map((func) =>
    func.id === action.functionData.id ? action.functionData : func
  );
  return {
    ...state,
    fonctions: newFonctions,
    error: null,
  };
};

const deleteFunction = (state, action) => {
  const newFonctions = state.fonctions.filter(
    (func) => func.id !== action.functionId
  );
  return {
    ...state,
    fonctions: newFonctions,
    error: null,
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_FUNCTIONS:
      return setFunctions(state, action);
    case actionTypes.SET_FUNCTIONS_LOADING:
      return setFunctionsLoading(state, action);
    case actionTypes.ADD_FUNCTION:
      return addFunction(state, action);
    case actionTypes.UPDATE_FUNCTION:
      return updateFunction(state, action);
    case actionTypes.DELETE_FUNCTION:
      return deleteFunction(state, action);
    // Tasks
    case actionTypes.SET_TASKS_LIST:
      return { ...state, tasks: action.tasks, error: null };
    case actionTypes.ADD_TASK_ITEM:
      return { ...state, tasks: [...state.tasks, action.taskData], error: null };
    case actionTypes.UPDATE_TASK_ITEM:
      return {
        ...state,
        tasks: state.tasks.map((t) => (t.id === action.taskData.id ? action.taskData : t)),
        error: null,
      };
    case actionTypes.DELETE_TASK_ITEM:
      return {
        ...state,
        tasks: state.tasks.filter((t) => t.id !== action.taskId),
        error: null,
      };
    default:
      return state;
  }
};

export default reducer;
